export default __webpack_public_path__ + "img/bHZPbhWX.c75d3eba.svg";